import { Group, Pagination, Select, Text, rem } from "@mantine/core";

type TablePaginationProps = {
  totalPages: number;
  currentPage: number;
  limit: number;
  onPageChange: (page: number) => void;
  onLimitSelect: (limit: string | null) => void;
};

const pageCountOptions = [
  { label: "10", value: "10" },
  { label: "25", value: "25" },
  { label: "50", value: "50" },
  { label: "100", value: "100" },
];

export default function TablePagination({
  totalPages,
  currentPage,
  onPageChange,
  onLimitSelect,
  limit,
}: TablePaginationProps) {
  return (
    <Group justify="space-between">
      <Group>
        <Pagination size={"sm"} value={currentPage} total={totalPages} onChange={onPageChange} />
        <Text>
          Page {currentPage} of {totalPages}
        </Text>
      </Group>

      <Group>
        <Text>Items</Text>
        <Select
          value={limit ? `${limit}` : null}
          size="xs"
          w={rem(70)}
          data={pageCountOptions}
          onChange={onLimitSelect}
        />
      </Group>
    </Group>
  );
}
